var r,n;function e(){if(n)return r;return n=1,r=function(r){return r instanceof Date}}export{e as __require};
//# sourceMappingURL=index.js.map
